import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import styled from "@emotion/styled";

import iconShadow from "leaflet/dist/images/marker-shadow.png";
import markerIcon from "assets/img/red-marker-icon.png";

const DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: iconShadow,
    shadowAnchor: [13, 20],
    iconSize: [25, 41],
    popupAnchor: [0, -10],
});

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex-grow: 1;
    min-height: 0;

    .leaflet-container {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        min-height: 120px;
        pointer-events: none;
    }
`;

type LocationMapSectionProps = {
    location?: number[] | null;
};

const LocationMapSection = ({ location }: LocationMapSectionProps) => {
    const hasValidLocation =
        location?.length === 2 &&
        location[0] != null &&
        location[1] != null;

    if (!hasValidLocation) {
        return <></>;
    }

    return (
        <Wrapper>
            <MapContainer
                center={[location[0], location[1]]}
                zoom={14}
                scrollWheelZoom={false} // Disable zooming with the mouse wheel
                dragging={false} // Disable dragging the map
                doubleClickZoom={false} // Disable zooming by double-clicking
                touchZoom={false} // Disable zooming on mobile devices
                keyboard={false} // Disable keyboard arrows and +/- keys. Even
                zoomControl={false} // Hide zoom control buttons
                attributionControl={false} // Hide "Leaflet" text on the bottom right
            >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker
                    position={[location[0], location[1]]}
                    icon={DefaultIcon}
                    interactive={false}
                />
            </MapContainer>
        </Wrapper>
    );
};

export default LocationMapSection;
